import { useSelector } from "react-redux";
import {
  BrowserRouter,
  Route,
  Routes,
} from "react-router-dom";
import { Sidebar } from "./pages/Sidebar";
import { UserList } from "./pages/userList/UserList";
import { MessageList } from "./pages/messages/MessageList";
import { MessageRegister } from "./pages/messages/MessageRegister";
import { Login } from "./pages/Login";
import { RegisterSend } from "./pages/RegisterSend";
import { Alerts } from "./components/alerts/Alerts";
import {
  selectAlert,
} from "./features/alert.slice";

import { AuthUserRoute } from "./pages/navi/AuthUserRouter";
import { UserInfo } from "./pages/userList/UserInfo";
import { EditPassword } from "./pages/userList/EditPassword";
import { Schedule } from "./pages/schedule/Schedule";
import { UsageSituation } from "./pages/usageSituation/UsageSituation";
import { GroupList } from "./pages/groups/GroupList";
import { EventParticipation } from "./pages/eventParticipation/EventParticipation";
import { MessageInfo } from "./pages/messages/MessageInfo";
import { ReplyButtonPage } from "./pages/replyButtons/ReplyButtonPage";
import { OnlineUrlSettingPage } from "./pages/onlineURLSetting/OnlineUrlSettingPage";
import { MovieMenuSettingPage } from "./pages/movieMenuSetting/MovieMenuSettingPage"
import { MenuSettingsPage } from "./pages/menuSettings/MenuSettingPage";
import { MunicipalitiesInfo } from "./pages/municipalitiesInfo/MunicipalitiesInfo";
import { ContactInformationSettingPage } from "./pages/contactInformationSetting/ContactInformationSettingPage";
import { LinkMenusPage } from "./pages/linkMenus/LinkMenusPage";
import { MatchingRequest } from "./pages/matching/MatchingRequest";
import { MatchingReceipt } from "./pages/matching/MatchingReceipt";
import { UsersIdcardCreate } from "./pages/userList/UsersIdcardCreate";
import { OptionContractSettingPage } from "./pages/municipalitiesInfo/OptionContractSettingPage";
import { MessageAttendance } from "./pages/messages/MessageAttendance";
import { MessageReply } from "./pages/messages/MessageReply";
import { UserSearch } from "./pages/messages/UserSearch";
import { QuestionnaireResults } from "./pages/messages/QuestionnaireResults";
import { PointAwardedList } from "./pages/pointAwarded/PointAwardedList";
import { PointAwardedInfo } from "./pages/pointAwarded/PointAwardedInfo";
import { PointHistoryList } from "./pages/pointHistory/PointHistoryList";
import { PointHistoryInfo } from "./pages/pointHistory/PointHistoryInfo";
import { PointAdjustmentPage } from "./pages/pointAdjustment/PointAdjustmentPage";
import { PointAdjustmentHistory } from "./pages/pointAdjustment/PointAdjustmentHistory";
import { PointAdjustmentInfo } from "./pages/pointAdjustment/PointAdjustmentInfo";

const App = () => {
  const alert = useSelector(selectAlert);

  return (
    <>
      {alert.isOpen && (
        <Alerts color={alert.color} text={alert.text} sbuText={alert.subText}/>
      )}

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AuthUserRoute><Sidebar /></AuthUserRoute>}>
            {/* 予定表 */}
            <Route path="schedule" element={<Schedule />} />
            {/* お知らせ */}
            <Route path="message" element={<MessageList />} />
            {/* お知らせ詳細 */}
            <Route path="message/:messageId/info" element={<MessageInfo />} />
            {/* 出欠一覧 */}
            <Route path="message/:messageId/attendance" element={<MessageAttendance />} />
            {/* 返信一覧 */}
            <Route path="message/:messageId/reply" element={<MessageReply />} />
            {/* 利用者一覧 */}
            <Route path="message/:messageId/attendance/UserSearch" element={<UserSearch />} />
            {/* アンケート結果 */}
            <Route path="message/:messageId/questionnaireResults" element={<QuestionnaireResults />} />
            {/* お知らせ一括登録 */}
            <Route path="messageRegister" element={<MessageRegister />} />
            {/* 利用状況 */}
            <Route path="usageSituation" element={<UsageSituation />} />
            {/* 利用者一覧 */}
            <Route path="userList" element={<UserList />} />
              {/* 利用者詳細 */}
              <Route path="userList/:userId/info" element={<UserInfo />} />
                {/* ポイント履歴詳細 */}
                <Route path="userList/:userId/info/:returnDisply/:pointHistoryId/info" element={<PointHistoryInfo />} />
              {/* パスワード変更 */}
              <Route path="userList/:userId/editPassword" element={<EditPassword />} />
            {/* 利用者IDカード作成 */}
            <Route path="usersIdcardCreate" element={<UsersIdcardCreate />} />
            {/* グループ */}
            <Route path="groupList" element={<GroupList />} />
            {/* イベント参加履歴 */}
            <Route path="eventParticipation" element={<EventParticipation />} />
            {/* イベント参加履歴 */}
            <Route path="eventParticipation/:messageId/" element={<EventParticipation />} />
            {/* 契約情報 */}
            <Route path="municipalitiesInfo" element={<MunicipalitiesInfo/>} />
            {/* オプション契約設定 */}
            <Route path="optionContractSetting" element={<OptionContractSettingPage />} />
            {/* 返信ボタン設定 */}
            <Route path="replyButtons" element={<ReplyButtonPage />} />
            {/* ミーティングURL設定 */}
            <Route path="onlineUrlSetting" element={<OnlineUrlSettingPage />} />
            {/* 動画メニュー設定 */}
            <Route path="movieMenuSetting" element={<MovieMenuSettingPage />} />
            {/* 連携メニュー */}
            <Route path="linkMenus" element={<LinkMenusPage />} />
            {/* 問い合わせ先設定 */}
            <Route path="contactInformationSetting" element={<ContactInformationSettingPage />} />
            {/* メニュー設定 */}
            <Route path="menuSettings" element={<MenuSettingsPage />} />
            {/* ポイント設定 */}
            <Route path="pointAwardedSettings" element={<PointAwardedList />} />
            {/* ポイント設定詳細 */}
            <Route path="pointAwardedSettings/:pointAwardedSettingsId/info" element={<PointAwardedInfo />} />
            {/* ポイント履歴 */}
            <Route path="pointHistoryList" element={<PointHistoryList />} />
            {/* ポイント履歴詳細 */}
            <Route path="pointHistoryList/:returnDisply/:pointHistoryId/info" element={<PointHistoryInfo />} />
            {/* ポイント調整 */}
            <Route path="pointAdjustmentPage" element={<PointAdjustmentPage />} />
            {/* ポイント調整履歴 */}
            <Route path="PointAdjustmentHistory" element={<PointAdjustmentHistory />} />
            {/* ポイント調整履歴詳細 */}
            <Route path="PointAdjustmentHistory/:pointAdjustmentId/info" element={<PointAdjustmentInfo />} />
          </Route>
          <Route path="/login" element={<Login></Login>} />
          <Route
            path="/register/send"
            element={<RegisterSend></RegisterSend>}
          />
          <Route path="/match-req/:tenantId/:hash" element={<MatchingRequest />} />
          <Route path="/match-req/:tenantId/:hash/:step" element={<MatchingRequest />} />
          <Route path="/match-rec/:tenantId/:hash/:requestId" element={<MatchingReceipt />} />
        </Routes>
        <Routes></Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
